import { Button, Col, Row, Tag } from "antd";
import dayjs from "dayjs";
const TableColumn = (navigateDetail, handlePrint, handleDownload) => {
  const data = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      width: 60,
      render: (text, record, index) => text,
    },
    {
      title: "Nomor",
      dataIndex: "invoice_number",
      key: "invoice_number",
      width: 180,
      sorter: (a, b) => {
        if (a.invoice_number === null || a.invoice_number === "-") return 1;
        if (b.invoice_number === null || b.invoice_number === "-") return -1;
        return a.invoice_number.localeCompare(b.invoice_number);
      },
      render: (invoice_number) => {
        if (invoice_number === null || invoice_number === "-") {
          return "-";
        } else {
          return invoice_number;
        }
      },
    },
    {
      title: "Customer Name",
      dataIndex: "client",
      key: "client",
      width: 180,
      sorter: (a, b) => {
        if (a.client?.name === null || a.client?.name === "-") return 1;
        if (b.client?.name === null || b.client?.name === "-") return -1;
        return a.client?.name.localeCompare(b.client?.name);
      },
      render: (client) => {
        if (client === null || client === "-") {
          return "-";
        } else {
          return client?.name;
        }
      },
    },
    {
      title: "Total",
      dataIndex: "grand_total",
      key: "grand_total",
      width: 150,
      sorter: (a, b) => {
        if (a.grand_total === null || a.grand_total === "-") return 1;
        if (b.grand_total === null || b.grand_total === "-") return -1;
        return a.grand_total - b.grand_total;
      },
      render: (grand_total) => {
        if (grand_total === null || grand_total === "-") {
          return "-";
        } else {
          return `Rp. ${grand_total?.toLocaleString("id-ID")}`;
        }
      },
    },
    {
      title: "Tanggal Terbit Invoice",
      dataIndex: "created_at",
      key: "created_at",
      width: 150,
      sorter: (a, b) => {
        if (a.created_at === null || a.created_at === "-") return 1;
        if (b.created_at === null || b.created_at === "-") return -1;
        return a.created_at.localeCompare(b.created_at);
      },
      render: (created_at) => {
        return created_at ? dayjs(created_at).format("DD-MM-YYYY") : "-";
      },
    },
    {
      title: "Tanggal Bayar",
      dataIndex: "paid_at",
      key: "paid_at",
      width: 150,
      sorter: (a, b) => {
        if (a.paid_at === null || a.paid_at === "-") return 1;
        if (b.paid_at === null || b.paid_at === "-") return -1;
        return a.paid_at.localeCompare(b.paid_at);
      },
      render: (paid_at) => {
        if (paid_at === null || paid_at === "-") {
          return "-";
        } else {
          return dayjs(paid_at).format("DD-MM-YYYY") ?? "-";
        }
      },
    },
    {
      title: "Status Pembayaran",
      dataIndex: "status",
      key: "status",
      width: 200,
      sorter: (a, b) => {
        if (a.status === null || a.status === "-") return 1;
        if (b.status === null || b.status === "-") return -1;
        return a.status.localeCompare(b.status);
      },
      render: (status) => {
        if (status === null || status === "") {
          return "-";
        } else {
          return status === "unpaid" ? (
            <Tag color="red">{"Gagal Bayar"}</Tag>
          ) : status === "pending" ? (
            <Tag color="orange">{"Belum Bayar"}</Tag>
          ) : status === "paid" ? (
            <Tag color="green">{"Lunas"}</Tag>
          ) : status === "checked" ? (
            <Tag color="green">{"Checked"}</Tag>
          ) : (
            "-"
          );
        }
      },
    },
    // Not final
    {
      title: "Status Verifikasi",
      dataIndex: "verification_status",
      key: "verification_status",
      width: 150,
      sorter: (a, b) => {
        if (a.verification_status === null || a.verification_status === "-")
          return 1;
        if (b.verification_status === null || b.verification_status === "-")
          return -1;
        return a.verification_status.localeCompare(b.verification_status);
      },
      render: (verification_status) => {
        if (verification_status === null || verification_status === "") {
          return "-";
        } else {
          return verification_status === "Pending" ? (
            <Tag color="orange">{"Pending"}</Tag>
          ) : (
            <Tag color="green">{verification_status}</Tag>
          );
        }
      },
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      width: 280,
      render: (resultData) => {
        return (
          <Row gutter={[8, 8]} size="middle">
            <Col>
              <Button type="primary" onClick={() => navigateDetail(resultData)}>
                Detail
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                style={{
                  backgroundColor: "#4caf50",
                  color: "#fff",
                  borderColor: "#4caf50",
                  width: "100%",
                }}
                onClick={() => handlePrint(resultData)}
              >
                Print
              </Button>
            </Col>
            <Col>
              <Button type="primary" onClick={() => handleDownload(resultData)}>
                Download
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];
  return data;
};
export default TableColumn;
